export function canExport(props) {
    return props && props.entities && props.entities.context && props.entities.context.source === 'cms';
}